import { readable, type Readable } from 'svelte/store'

export const emptyReloadable: Reloadable<[]> = {
  subscribe: readable<[]>([]).subscribe,
  reload: async () => [],
}

export type Reloadable<T> = Readable<T> & {
  reload: () => Promise<T>
}
